import React from 'react';
import PropTypes from 'prop-types';
import { Spinner } from 'react-bootstrap';

function LoadingOverlay(props) {
  const style = {
    position: 'absolute',
    top: 0,
    right: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  };

  if (!props.hideOpacity) {
    style.backgroundColor = props.color ? props.color : 'white';
    style.opacity = props.opacity ? props.opacity : 0.8;
  }

  return (
    <div style={style}>
      <Spinner animation='border' variant='primary' />
    </div>
  );
}

LoadingOverlay.propTypes = {
  hideOpacity: PropTypes.bool
};

export default LoadingOverlay;
